import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ButtonLink = styled(Link)`
    position: relative;
    display: block;
`;

const ButtonLabel = styled.span`
    position: absolute;
    top: -6px;
    right: -6px;
    margin-right: 0;
    background-color: #db2828;
    border-color: #db2828;
    color: #fff;
    width: 18px;
    height: 18px;
    line-height: 17px;
    text-align: center;
    border-radius: 500rem;
    font-size: 12px;
    font-family: Montserrat, Helvetica, Verdana, Arial, sans-serif;
`;

const LabeledLink = ({ label, children, ...rest }) => (
    <ButtonLink {...rest}>
        <React.Fragment key="children">{children}</React.Fragment>
        <React.Fragment key="label">{label && <ButtonLabel>{label}</ButtonLabel>}</React.Fragment>
    </ButtonLink>
);

export default LabeledLink;

LabeledLink.propTypes = {
    children: PropTypes.node,
    label: PropTypes.node,
    to: PropTypes.string.isRequired,
};
